import React, { useContext, useEffect, useRef, useState } from "react";
import {
  NewOrderContext,
  NewOrderContextProvider,
} from "../../context/NewOrderContext";
import "./NewMultipleOrder.scss";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import {
  createNewMultipleOrder,
  getTermsAndCondition,
  getVendorInfo,
} from "../../Services/PartRequestManagementService";
import { PartRequestManagemenProvider } from "../../context/PartRequestManagementContext";
import { Expandable } from "../../../../components/Expandable/Expandable";
import { Popover, Tooltip } from "@mui/material";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../contexts/DropdownsContext";
import OrderListDetails from "./OrderListDetails";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import Skeleton from "react-loading-skeleton";
import Input from "../../../../components/Inputs/Input";
import { use } from "react";

const dropdownIds = [106, 107, 19, 121, 94, 74, 108, 109, 110, 111, 124];
const dropdownNames = {
  106: "orderType",
  107: "priority",
  121: "locationId",
  19: "siteId",
  94: "vendorId",
  74: "currencyId",
  108: "billTo",
  109: "paymentTermsId",
  110: "shipViaVendorId",
  111: "shipViaAccountId",
};
const requiredFields = {
  orderType: true,
  priority: true,
  locationId: true,
  siteId: true,
  vendorId: true,
  currencyId: true,
  billTo: true,
  paymentTermsId: true,
};
const defaultGeneralEmptyValues = {
  orderType: null,
  priority: null,
  locationId: null,
  siteId: null,
  billTo: null,
  vendorId: null,
  currencyId: null,
  orderFooterNotes: null,
  paymentTermsId: null,
  legacySystemReference: "",
  shipViaVendorId: null,
  shipViaAccountId: null,
  shipViaRemarks: "",
  supplyChainUser: "",
  orderNumber: null,
  sourceOfPrice: null,
};
const OrderMultipleGeneralInfo = ({
  parts,
  fromQuote,
  quoteToOrderList,
  vendorParentId,
}) => {
  const [displayForm, setDisplayForm] = useState(false);
  const [defaults, setDefaults] = useState({});
  const {
    generalInfo,
    setGeneralInfo,
    vendorGeneralInfoList,
    setVendorGeneralInfoList,
  } = useContext(NewOrderContext);
  const [values, setValues] = useState({ ...defaultGeneralEmptyValues });
  const [vendorInfoLoading, setVendorInfoLoading] = useState(false);
  const [vendorInfo, setVendorInfo] = useState(null);
  const [companyParameter, _] = useState([
    { columnName: "companyId", value: localStorage.getItem("u_company_id") },
    { columnName: "accountId", value: localStorage.getItem("u_account_id") },
  ]);
  const [locationParameters, setLocationParameters] = useState([]);
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  const [errorState, setErrorState] = useState({});
  // const [defaults, setDefaults] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const id_popover = open ? "simple-popover" : undefined;
  const id_popover1 = open1 ? "simple-popover" : undefined;

  const [anchorEl2, setAnchorEl2] = useState(null);
  const open2 = Boolean(anchorEl2);
  const id_popover2 = open2 ? "simple-popover" : undefined;
  const [termsAndCondition, setTermsAndCondition] = useState("...");

  useEffect(() => {
    getTermsAndCondition(localStorage.getItem("u_company_id"))
      .then((response) => {
        setTermsAndCondition(response.data.load ?? "...");
      })
      .catch((error) => {})
      .finally(() => {});
  }, []);
  useEffect(() => {
    let locationsId = [];
    if (fromQuote) {
      for (const i in quoteToOrderList) {
        const part = quoteToOrderList[i];
        if (locationsId.includes(part.location_id)) {
          continue;
        }
        locationsId.push(part.location_id);
      }
      const quote = quoteToOrderList[0];
      let foundVendorInfo = false;
      if (vendorGeneralInfoList && vendorGeneralInfoList.length > 0) {
        const vendorInfo = vendorGeneralInfoList.find(
          (item) => item.vendorParentId === vendorParentId
        );
        if (vendorInfo) {
          foundVendorInfo = true;
          setValues((prev) => ({
            ...prev,
            ...vendorInfo.generalInfo,
          }));
          setDefaults((prev) => ({
            ...prev,
            ...vendorInfo.generalInfo,
          }));
          setGeneralInfo((prev) => ({
            ...prev,
            ...vendorInfo.generalInfo,
          }));
        }
      }
      if (!foundVendorInfo) {
        setValues((prev) => ({
          ...prev,
          vendorId: quote.vendor_id,
          currencyId: quote.currency_id,
          currencyName: quote.currency,
          locationId: quote.location_id,
          billTo: quote.location_id,
        }));
        setDefaults((prev) => ({
          ...prev,
          vendorId: quote.vendor_id,
          currencyId: quote.currency_id,
          currencyName: quote.currency,
          locationId: quote.location_id,
          billTo: quote.location_id,
        }));
        setGeneralInfo((prev) => ({
          ...prev,
          vendorId: quote.vendor_id,
          currencyId: quote.currency_id,
          currencyName: quote.currency,
          locationId: quote.location_id,
          billTo: quote.location_id,
          vendorParentId: vendorParentId,
        }));
      }

      setVendorInfoLoading(true);
      getVendorInfo(quote.vendor_id)
        .then((vendorInfo) => {
          const response = vendorInfo.data.load;
          setVendorInfo(response);
          setVendorInfoLoading(false);
        })
        .catch((error) => {
          setVendorInfoLoading(false);
        })
        .finally(() => {
          setVendorInfoLoading(false);
        });
    } else {
      for (const i in parts) {
        const part = parts[i];
        if (locationsId.includes(part.pr_location_id)) {
          continue;
        }
        locationsId.push(part.pr_location_id);
      }
    }

    setLocationParameters([
      { columnName: "accountId", value: localStorage.getItem("u_account_id") },
      { columnName: "locationsReq", value: locationsId },
    ]);
    setDropdownIds(dropdownIds);
  }, []);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
      if (generalInfo) {
        setValues((prev) => ({
          ...prev,
          ...generalInfo,
        }));
      }
    }
  }, [dropdownsData]);

  useEffect(() => {
    setVendorGeneralInfoList((prev) => {
      const newList = [...prev];
      const existingIndex = newList.findIndex(
        (item) => item.vendorParentId === vendorParentId
      );

      if (existingIndex !== -1) {
        newList[existingIndex] = {
          vendorParentId,
          generalInfo,
        };
      } else {
        newList.push({
          vendorParentId,
          generalInfo,
        });
      }

      return newList;
    });
  }, [generalInfo]);
  const handleDropdownValue = (value, name, data) => {
    if (name == "vendorId") {
      const { id } = value;
      setVendorInfoLoading(true);
      getVendorInfo(id)
        .then((vendorInfo) => {
          const response = vendorInfo.data.load;
          setVendorInfo(response);
          setVendorInfoLoading(false);
          setValues((prev) => ({
            ...prev,
            currencyId: 1,
            currencyName: "USD",
          }));
          setDefaults((prev) => ({
            ...prev,
            currencyId: 1,
            currencyName: "USD",
          }));

          setGeneralInfo((prev) => ({
            ...prev,
            currencyId: 1,
            currencyName: "USD",
          }));
        })
        .catch((error) => {
          setVendorInfoLoading(false);
        })
        .finally(() => {
          setVendorInfoLoading(false);
        });
    }
    if (name == "locationId") {
      const { id } = value;
      setValues((prev) => ({
        ...prev,
        billTo: id,
      }));
      setDefaults((prev) => ({
        ...prev,
        billTo: id,
      }));
    }
    changeValue({ target: { name, value: value[data], completeValue: value } });

    setDefaults((prev) => ({
      ...prev,
      ...{ [name]: " " },
    }));
  };

  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;

    if (name in requiredFields) {
      setErrorState((prev) => ({
        ...prev,
        [name]: value || completeValue ? "" : "Required",
      }));
    }
    let updatedValues = { ...values, [name]: value };
    if (name == "currencyId") {
      updatedValues.currencyName = completeValue?.prefix || "";
    }
    if (name == "locationId") {
      updatedValues.billTo = completeValue?.id || null;
    }
    setValues(updatedValues);
    setGeneralInfo(updatedValues);
  };
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  return (
    <>
      <div className="new-order-full-content-body-top">
        <div className="new-order-full-content-body-top-left">
          <b>General Information</b>
        </div>
        <div className="new-order-full-content-body-top-right">
          <button className="note-terms-footer-button" onClick={handleClick1}>
            <span>Terms and Conditions</span>
            <i className="icon-terms-condition"></i>
          </button>
          <Popover
            id={id_popover1}
            open={open1}
            anchorEl={anchorEl1}
            onClose={handleClose1}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            slotProps={{
              paper: {
                style: {
                  borderRadius: "12px",
                  boxShadow: "var(--pop-over-shadow)",
                },
              },
            }}
          >
            <div className="terms-condition-popover-content">
              <div className="terms-condition-popover-header">
                <div className="terms-condition-title">
                  <i className="icon-terms-condition"></i>
                  <b>Terms and Conditions</b>
                </div>
                <button
                  className="outlined icon small-size"
                  onClick={handleClose1}
                >
                  <i className="icon-cross"></i>
                </button>
              </div>
              <div className="terms-condition-popover-body">
                <p>{termsAndCondition}</p>
              </div>
            </div>
          </Popover>
          <div className="info-order-tag">
            <p>Supply Chain User</p>
            <b>Eric Haag</b>
          </div>
          <div className="info-order-tag">
            <p>Order Number</p>
            <b>--</b>
          </div>
        </div>
      </div>
      <div className="new-order-form-general-info">
        <div className="new-order-form-general-info-row1">
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              required={true}
              key={106}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[106], data)
              }
              error={errorState[dropdownNames[106]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 106)}
              preSelectValue={defaults?.[dropdownNames[106]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              required={true}
              key={107}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[107], data)
              }
              error={errorState[dropdownNames[107]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 107)}
              preSelectValue={defaults?.[dropdownNames[107]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              required={true}
              key={121}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[121], data)
              }
              parameters={locationParameters}
              error={errorState[dropdownNames[121]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 121)}
              preSelectValue={defaults?.[dropdownNames[121]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              required={true}
              key={19}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[19], data)
              }
              error={errorState[dropdownNames[19]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 19)}
              preSelectValue={defaults?.[dropdownNames[19]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              required={true}
              key={108}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[108], data)
              }
              parameters={companyParameter}
              error={errorState[dropdownNames[108]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 108)}
              preSelectValue={defaults?.[dropdownNames[108]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <div className="vendor-container-info">
              <Dropdowns
                context={{
                  dropdownsData,
                  setDropdownsData,
                  setDropdownIds,
                  dropdownDefaultOptions,
                }}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                disabled={fromQuote}
                required={true}
                key={94}
                onOptionSelect={(value, data) =>
                  handleDropdownValue(value, dropdownNames[94], data)
                }
                error={errorState[dropdownNames[94]]}
                hideRequiredLabel={true}
                showPagination={false}
                parameters={companyParameter}
                data={dropdownsData.find((e) => e.id === 94)}
                preSelectValue={defaults?.[dropdownNames[94]]}
              />
              <Tooltip title="View More Information" placement="top">
                <div
                  className={`more-options-container }`}
                  onClick={handleClick}
                >
                  <span>
                    <i className="icon-more-horizontal"></i>
                  </span>
                </div>
              </Tooltip>
              <Popover
                id={id_popover}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                slotProps={{
                  paper: {
                    style: {
                      borderRadius: "12px",
                      boxShadow: "var(--pop-over-shadow)",
                    },
                  },
                }}
              >
                <div className="vendor-popover-content">
                  <div className="vendor-popover-header">
                    <b>Additional Information</b>
                    <button
                      className="outlined icon small-size"
                      onClick={handleClose}
                    >
                      <i className="icon-cross"></i>
                    </button>
                  </div>
                  <div className="vendor-popover-body">
                    <div className="vendor-popover-body-item">
                      <p>Country</p>
                      <b>{vendorInfo?.country ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>State/Province</p>
                      <b>{vendorInfo?.state ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>City</p>
                      <b>{vendorInfo?.city ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>Postal Code</p>
                      <b>{vendorInfo?.postalCode ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>Phone Number</p>
                      <b>{vendorInfo?.phoneNumber ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>Email</p>
                      <b>{vendorInfo?.email ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>Contact Name</p>
                      <b>{vendorInfo?.contactName ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>Address</p>
                      <b>{vendorInfo?.address ?? "--"}</b>
                    </div>
                    <div className="vendor-popover-body-item">
                      <p>Vendor Type</p>
                      <b>{vendorInfo?.vendorType ?? "--"}</b>
                    </div>
                  </div>
                </div>
              </Popover>
            </div>
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <div className="class-vendor-score">
              <p>Score</p>
              <div className="score-container">
                <b>{vendorInfo?.socre ?? "0.0"}</b>
                <i className="icon-favorite"></i>
              </div>
            </div>
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={fromQuote}
              required={true}
              key={74}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[74], data)
              }
              error={errorState[dropdownNames[74]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 74)}
              preSelectValue={defaults?.[dropdownNames[74]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
        </div>
        <div className="new-order-form-general-info-row2">
          {displayForm ? (
            <>
              <button
                className="note-terms-footer-button"
                onClick={handleClick2}
              >
                <span>Order Footer Notes</span>
                <i className="icon-notes"></i>
              </button>
              <Popover
                id={id_popover2}
                open={open2}
                anchorEl={anchorEl2}
                onClose={handleClose2}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                slotProps={{
                  paper: {
                    style: {
                      borderRadius: "12px",
                      boxShadow: "var(--pop-over-shadow)",
                    },
                  },
                }}
              >
                <div className="order-footer-popover-content">
                  <div className="order-footer-popover-content-header">
                    <div className="order-footer-title">
                      <i className="icon-notes"></i>
                      <b>Order Footer Notes</b>
                    </div>
                    <button
                      className="outlined icon small-size"
                      onClick={handleClose2}
                    >
                      <i className="icon-cross"></i>
                    </button>
                  </div>
                  <div className="order-footer-popover-content-body">
                    <Input
                      style={{ height: "100%", alignItems: "normal" }}
                      onChange={changeValue}
                      name="orderFooterNotes"
                      multiLine={true}
                      placeholder={"Order Footer Notes"}
                      disableAutocomplete={true}
                      label={""}
                      value={values["orderFooterNotes"]}
                    />
                  </div>
                </div>
              </Popover>
            </>
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              required={true}
              key={109}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[109], data)
              }
              error={errorState[dropdownNames[109]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 109)}
              preSelectValue={defaults?.[dropdownNames[109]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}

          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              key={110}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[110], data)
              }
              error={errorState[dropdownNames[110]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 110)}
              preSelectValue={defaults?.[dropdownNames[110]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={false}
              key={111}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[111], data)
              }
              error={errorState[dropdownNames[111]]}
              hideRequiredLabel={true}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 111)}
              preSelectValue={defaults?.[dropdownNames[111]]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
          {displayForm ? (
            <Input
              style={{ gridColumn: "span 1" }}
              onChange={changeValue}
              name="shipViaRemarks"
              disableAutocomplete={true}
              label={"Ship Via Remarks"}
              value={values["shipViaRemarks"]}
            />
          ) : (
            <Skeleton height="1.9rem" width="100%" />
          )}
        </div>
      </div>
    </>
  );
};
const CalculateTotalOrder = (vendorId) => {
  const { vendorLineNumberInfoList } = useContext(NewOrderContext);
  const [totalOrder, setTotalOrder] = useState(0);
  useEffect(() => {
    if (!vendorLineNumberInfoList) return;
    let total = 0;
    const matchingLineInfo = vendorLineNumberInfoList?.find(
      (entry) => entry.vendorParentId === vendorId.vendorParentId
    );
    for (const key in matchingLineInfo?.lineNumberInfo) {
      const info = matchingLineInfo?.lineNumberInfo[key];
      if (info && info.totalCost) {
        total += info.totalCost;
      }
    }
    setTotalOrder(total);
  }, [vendorLineNumberInfoList]);

  return (
    <b className="total-order-per-line">
      {" "}
      {new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(totalOrder)}{" "}
    </b>
  );
};
const NewOrderMultipeHeader = ({
  onClose,
  okAction,
  fromQuote,
  quoteToOrderList,
}) => {
  const {
    lineNumberInfo,
    vendorLineNumberInfoList,
    vendorGeneralInfoList,
    generalInfo,
    countDetails,
  } = useContext(NewOrderContext);
  const [totalOrder, setTotalOrder] = useState(0);

  const { successMsg, warningMsg, infoMsg } = useSnackBar();

  useEffect(() => {
    if (lineNumberInfo) {
      let total = 0;
      for (const key in lineNumberInfo) {
        const info = lineNumberInfo[key];
        if (info && info.totalCost) {
          total += info.totalCost;
        }
      }
      setTotalOrder(total);
    }
  }, [lineNumberInfo]);

  const isDisabled = () => {
    if (!vendorGeneralInfoList) return true;
    for (const vendorInfo of vendorGeneralInfoList) {
      if (!vendorInfo.generalInfo) {
        return true;
      }
      for (const key in requiredFields) {
        if (
          requiredFields[key] &&
          (!vendorInfo.generalInfo[key] || vendorInfo.generalInfo[key] === "")
        ) {
          return true;
        }
      }
    }

    if (!vendorLineNumberInfoList || vendorLineNumberInfoList.length === 0) {
      return true;
    }
    for (const vendorInfoLine of vendorLineNumberInfoList) {
      if (!vendorInfoLine.lineNumberInfo) {
        return true;
      }
      for (const key in vendorInfoLine.lineNumberInfo) {
        const info = vendorInfoLine.lineNumberInfo[key];
        if (
          !info ||
          !info.orderQty ||
          info.orderQty === "" ||
          info.orderQty <= 0 ||
          info.unitCost === undefined ||
          !info.unitCost ||
          info.unitCost === "" ||
          !info.partCondition ||
          info.partConditionName === "" ||
          !info.estDeliveryDate
        ) {
          return true;
        }
      }
    }

    return false;
  };
  const generateOrder = () => {
    let orderList = [];
    for (const vendorInfo of vendorGeneralInfoList) {
      const vendorId = vendorInfo.vendorParentId;
      const lineInfo = vendorLineNumberInfoList.find(
        (entry) => entry.vendorParentId === vendorId
      );
      const firstKey = Object.keys(lineInfo.lineNumberInfo)[0];
      const firstItem = lineInfo.lineNumberInfo[firstKey];
      const companyId = firstItem.companyId;
      let orderData = {
        orderType: vendorInfo.generalInfo.orderType,
        priority: vendorInfo.generalInfo.priority,
        locationId: vendorInfo.generalInfo.locationId,
        siteId: vendorInfo.generalInfo.siteId,
        billToId: vendorInfo.generalInfo.billTo,
        vendorId: vendorInfo.generalInfo.vendorId,
        currencyId: vendorInfo.generalInfo.currencyId,
        extraFooterNotes: vendorInfo.generalInfo.orderFooterNotes,
        paymentTermsId: vendorInfo.generalInfo.paymentTermsId,
        shipViaVendorId: vendorInfo.generalInfo.shipViaVendorId,
        shipViaAccountId: vendorInfo.generalInfo.shipViaAccountId,
        shipViaRemarks: vendorInfo.generalInfo.shipViaRemarks,
        supplyChainUserId: parseInt(localStorage.getItem("u_id")),
        companyId: companyId,
      };
      const detailsList = [];
      for (const key in lineInfo.lineNumberInfo) {
        const part = lineInfo.lineNumberInfo[key];
        const prnInfos = part.prnInfo;
        const totalRequired = prnInfos.reduce(
          (sum, prn) => sum + prn.quantity_required,
          0
        );
        const remainingQty = part.orderQty - totalRequired;
        prnInfos.forEach((prn, index) => {
          let quantityOrder = prn.quantity_required;
          if (index === 0) {
            quantityOrder += remainingQty;
          }
          detailsList.push({
            partRquestId: prn.prn_id,
            partId: part.partNumber,
            lineNumber: key,
            uomId: part.uomId,
            partConditionId: part.partCondition,
            quantityOrder: quantityOrder,
            unitPrice: parseFloat(part.unitCost),
            estDeliveryDate: new Date(part.estDeliveryDate).toISOString(),
            freeOfCharge: part.freeOfCharge,
            duty: parseFloat(part.duty),
            freightCost: parseFloat(part.freightCost),
            quoteId: part.quote_id,
            taskCardId: prn.tc_fnd,
            tax: parseFloat(part.tax),
            discountPercentage: part.discountPercentage,
            capitalExpenditure: part.capitalExpenditure || "",
          });
        });
      }
      orderData.detailsList = detailsList;
      orderList.push(orderData);
    }
    createNewMultipleOrder(orderList)
      .then((response) => {
        successMsg("Orders were generated successfully.");
        okAction();
        onClose();
      })
      .catch((error) => {
        console.error("Error generating order:", error);
      });
  };

  return (
    <>
      <div className="new-order-full-content-header">
        <div className="new-order-full-content-header-left">
          <div className="new-order-full-content-header-left-title">
            <i className="icon-stores"></i>
            <b>
              New Order{" "}
              {fromQuote && (
                <p>Cod RFQ {quoteToOrderList[0].quote_request_id}</p>
              )}
            </b>
          </div>
        </div>
        <div className="new-order-full-content-header-right">
          {/* <b>Order Total</b>
          <b className="total-price">
            {new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(totalOrder)}{" "}
            {generalInfo?.currencyName ?? "--"}
          </b>
          <p className="order-summary">Order Summary</p> */}
          {/* <button className="filled">Save Draft</button> */}
          <button
            className={`generate-order-button  ${
              isDisabled() ? "disabled" : ""
            }`}
            onClick={generateOrder}
          >
            Generate
          </button>
          <button className="outlined icon small-size" onClick={onClose}>
            <i className="icon-cross"></i>
          </button>
        </div>
      </div>
      <hr></hr>
    </>
  );
};
export const NewMultipleOrder = ({
  item,
  fromQuote,
  onClose,
  okAction,
  quoteToOrderList,
  uniqueVendors,
}) => {
  const [openSubStates, setOpenSubStates] = useState({});
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);

  const toggleOpenSubState = (aircraftId, open) => {
    closeAllOpenSubStates();
    setTimeout(() => {
      setOpenSubStates((prevState) => ({
        ...prevState,
        [aircraftId]: open,
      }));
    }, 100);
  };
  const closeAllOpenSubStates = () => {
    setOpenSubStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, []);

  return (
    <PartRequestManagemenProvider>
      <NewOrderContextProvider>
        <div className="new-order-full-content">
          <NewOrderMultipeHeader
            onClose={onClose}
            okAction={okAction}
            fromQuote={fromQuote}
            quoteToOrderList={quoteToOrderList}
          ></NewOrderMultipeHeader>
          <div className="new-order-vendor-header">
            <b>Company</b>
            <b>Vendor Selected</b>
            <b>Score</b>
            <b>Currency</b>
            <b>PN(s)</b>
            <b>Total Order</b>
          </div>
          <div className="new-order-vendor-list">
            {uniqueVendors.map((item, idx) => (
              <Expandable
                key={`${item?.vendor_id}-${idx}-quote-list`}
                name={`${item?.vendor_id}-quote-list-${idx}`}
                summary={
                  <React.Fragment key={`${item.vendor_id}-${idx}-prn`}>
                    <div
                      className={`new-order-vendor-list-container ${
                        openSubStates[item?.vendor_id] ? "active" : ""
                      }`}
                    >
                      {/* <PartImage item={item} /> */}
                      {["company_name", "vendor_name", "score", "currency"].map(
                        (label) => (
                          <div className={`property`} key={label}>
                            <Tooltip
                              title={
                                tooltips[`${item.vendor_id}-${label}`]
                                  ? item[label]
                                  : ""
                              }
                              arrow
                            >
                              {label == "vendor_name" ? (
                                <p
                                  className="bold-font"
                                  ref={(el) => {
                                    if (el) {
                                      propertyRefs.current[
                                        `${item.vendor_id}-${label}`
                                      ] = el;
                                    }
                                  }}
                                >
                                  {label == "vendor_name"
                                    ? item["vendor_id"] + " - " + item[label]
                                    : item[label]}
                                </p>
                              ) : label == "score" ? (
                                <div className="score-container">
                                  <i className="icon-favorite"> </i>
                                  <p
                                    className="light-font"
                                    ref={(el) => {
                                      if (el) {
                                        propertyRefs.current[
                                          `${item.vendor_id}-${label}`
                                        ] = el;
                                      }
                                    }}
                                  >
                                    {item[label] || "--"}
                                  </p>
                                </div>
                              ) : (
                                <p
                                  className="light-font"
                                  ref={(el) => {
                                    if (el) {
                                      propertyRefs.current[
                                        `${item.vendor_id}-${label}`
                                      ] = el;
                                    }
                                  }}
                                >
                                  {item[label]}
                                </p>
                              )}
                            </Tooltip>
                          </div>
                        )
                      )}
                      <div className="total-pns-container">
                        <p className="light-font">{item.pns?.length}</p>
                      </div>

                      {
                        <CalculateTotalOrder
                          vendorParentId={item?.vendor_id}
                        ></CalculateTotalOrder>
                      }
                    </div>
                  </React.Fragment>
                }
                isOpen={openSubStates[item?.vendor_id]}
                onToggle={(open) => toggleOpenSubState(item?.vendor_id, open)}
              >
                {openSubStates[item?.vendor_id] && (
                  <div className="new-order-vendor-list-container-content">
                    <DropdownsProvider>
                      <OrderMultipleGeneralInfo
                        fromQuote={fromQuote}
                        vendorParentId={item.vendor_id}
                        quoteToOrderList={item.pns}
                      ></OrderMultipleGeneralInfo>
                    </DropdownsProvider>

                    <OrderListDetails
                      fromQuote={fromQuote}
                      vendorParentId={item.vendor_id}
                      quoteToOrderList={item.pns}
                    ></OrderListDetails>
                  </div>
                )}
              </Expandable>
            ))}
          </div>
        </div>
      </NewOrderContextProvider>
    </PartRequestManagemenProvider>
  );
};
